import React, { useEffect, useState } from "react";
import SapakimHead from "./SapakimHead";
import { db } from "../Components/Firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { useParams } from "react-router-dom";
import "../Styles/Sapakim/SDocs.css";

function SDocs() {
  const { UID } = useParams();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch docs for this supplier
  const loadDocs = async () => {
    setLoading(true);
    try {
      const docsQuery = query(collection(db, "Docs"), where("SUID", "==", UID));
      const snapshot = await getDocs(docsQuery);
      const list = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setDocs(list);
    } catch (err) {
      console.error("Error loading docs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDocs();
  }, [UID]);

  return (
    <React.Fragment>
      <SapakimHead />

      <div className="sdocs-container" dir="rtl">
        <h2 className="title">מסמכים שלי</h2>

        {loading ? (
          <p className="loading">טוען מסמכים...</p>
        ) : docs.length === 0 ? (
          <p className="no-docs">לא נמצאו מסמכים</p>
        ) : (
          <div className="docs-grid">
            {docs.map((docItem) => (
              <div className="doc-card" key={docItem.id}>
                <h3>{docItem.name}</h3>
                
                {/* Show created date if exists */}
                {docItem.CreatedAt && (
                  <p className="created-at">
                    נוצר ב: {new Date(docItem.CreatedAt.seconds * 1000).toLocaleString("he-IL")}
                  </p>
                )}

                <ul>
                  {docItem.files.map((fileUrl, idx) => (
                    <li key={idx}>
                      <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                        {fileUrl.split("/").pop()}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default SDocs;
